export const TargetMenuModalTranslationJP = {
  TargetMenuModal: {
    target_menu_bar_guidance: 'ご案内：（{{name}}）',
    target_menu_overlay_function: '任意オーバーレイ名：（{{name}}）',
    target_menu_daily_menu: '日替わり曜日指定：（{{name}}）',
    target_menu_quantity_order_limit: 'コース注文数制限：（{{name}}）',
    target_menu_shabu_sukiyaki: '({{name}}）',
    target_menu_wizard: 'ウィザード名：（{{name}}）',
    save_success: '対象メニューを追加しました。',
    delete_success: 'データを削除しました',
    delete_success_daily_menu: '保存しました',

    Title: {
      head_title: '対象メニュー一覧',
    },
    Button: {
      delete: '削除',
      add_new: '追加',
    },
    Table: {
      selection: '選択',
      menu_code: 'メニューコード',
      name: 'メニュー名',
    },
    Warn: {
      warn_confirm_delete_default: '対象メニューをリストから削除します。よろしいですか？',
      warn_confirm_delete_overlay_function:
        '対象メニューをリストから削除します。対象メニューの任意オーバーレイ設定が「設定無し」に変更されます。よろしいですか？',
      warn_confirm_delete_menu_quantity_order_limit:
        '対象メニューをリストから削除します。対象メニューの注文数制限設定が「設定無し」に変更されます。よろしいですか？',
    },
  },
};
